import { render } from "./ProblemDetailsScreen.vue?vue&type=template&id=83e5325c&scoped=true"
import script from "./ProblemDetailsScreen.vue?vue&type=script&lang=js"
export * from "./ProblemDetailsScreen.vue?vue&type=script&lang=js"

import "./ProblemDetailsScreen.vue?vue&type=style&index=0&id=83e5325c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e5325c"]])

export default __exports__